import { Component, OnInit, OnDestroy } from '@angular/core';
import { CardService }        from '@omnipas/services/card.service';
import { EnvironmentService } from '@omnipas/services/environment.service';
import { ListService }        from '@omnilib/services/list.service';
import { LoadingService }     from '@omnipas/services/loading.service';
import { MessageService }     from '@omnipas/services/message.service';
import { PageHeaderService }  from '@omnipas/services/pageheader.service';
import { PhotoService }       from '@omnipas/services/photo.service';
import { RouterService }      from '@omnipas/services/router.service';

@Component({
  selector: 'omnipas-photoresult',
  templateUrl: './photoresult.component.html'
})
export class PhotoResultComponent implements OnInit, OnDestroy {

  initialized:      boolean = false;
  deliveryaddress:  boolean = false;
  deliveryaddress2: boolean = false;
  createcard:       boolean = false;

  constructor ( public card:        CardService
              , public environment: EnvironmentService
              , public list:        ListService
              , public loading:     LoadingService
              , public message:     MessageService
              , public pageheader:  PageHeaderService
              , public photo:       PhotoService
              , public router:      RouterService
              ) {
  }

  async ngOnInit() {
    this.router.toggleshowwait( true );

    this.initialized = false;

    if ( this.list.emptyList( this.router.persondata ) ) {
      this.router.logout();
    } else {
      this.pageheader.setPageHeader( 'pagetitle.photoresult' );
    }

    this.deliveryaddress  = this.message.success
                         && this.environment.getEnvValue('deliveryaddress')
                         && this.photo.firstphoto
                         && ( this.list.getValue( this.router.persondata, 'cardholderProfile', true ).toLowerCase() == 'student' );

    this.deliveryaddress2  = this.message.success
                         && this.environment.getEnvValue('deliveryaddress2')
                         && this.photo.firstphoto
                         && ( this.list.getValue( this.router.persondata, 'cardholderProfile', true ).toLowerCase() == 'student' );

    // Create the card here on the first photo. This runs regardless of whether a
    // delivery address flow follows: the delivery components only process the
    // address, the card is always created at this point. Preconditions mirror the
    // delivery gates (success + first photo + student), minus the address stuff.
    this.createcard      = this.message.success
                         && this.photo.firstphoto
                         && ( this.list.getValue( this.router.persondata, 'cardholderProfile', true ).toLowerCase() == 'student' );

    if ( this.createcard ) {
      if ( await this.card.create() ) {
        this.message.setSuccessMessage( 'requestcard.success' );
      } else {
        this.message.setErrorMessage( 'requestcard.failure' );
      }
    }

    this.initialized     = true;
    this.router.toggleshowwait( false );
  }

  logout() {
    this.router.logout();
  }

  back() {
    this.router.goTo('photo');
  }

  continue() {
    if(this.deliveryaddress) {
      this.router.goTo('deliveryaddress');
    } else if (this.deliveryaddress2) {
      this.router.goTo('deliveryaddress2')
    }
  }

  ngOnDestroy() {
    return;
  }

}
